















import { Component, Vue } from "vue-property-decorator";

import Candle from "@/components/Candle.vue";
import Greeting from "@/components/Greeting.vue";
import Letters from "@/components/Letters.vue";

@Component({
  components: {
    Candle,
    Greeting,
    Letters,
  },
})
export default class TheEntryPage extends Vue {
  private initialized = false;
  private readerName: string | null = null;

  mounted() {
    // refresh cookie
    if (this.$cookies.isKey("readerName")) {
      this.readerName = this.$cookies.get("readerName");
      this.$cookies.set("readerName", this.readerName);
    }
    this.initialized = true;
  }

  private handleReaderName(name: string) {
    this.readerName = name;
    this.$cookies.set("readerName", this.readerName);
  }
}
